import axios from 'axios'

class ProductService {
  index () {
    return axios.get('/api/client-account/products')
  }
}

export default new ProductService()
